import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of as observableOf } from 'rxjs';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { DataModule } from './data/data.module';
import { AnalyticsService } from './utils/analytics.service';
import { FirebaseEmailPassAuthProvider } from './auth/firebase-email-pass-auth.provider';
import { environment } from '../../environments/environment';

const socialLinks = [];

// Login goes straight to Firebase Auth's REST API with the project's web API key.
const firebaseAuth = 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/';
const firebaseKey = '?key=' + environment.config.apiKey;

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf('guest');
  }
}

export const NB_CORE_PROVIDERS = [
  ...DataModule.forRoot().providers,
  ...NbAuthModule.forRoot({
    providers: {
      email: {
        service: FirebaseEmailPassAuthProvider,
        config: {
          delay: 3000,
          baseEndpoint: '',
          login: {
            rememberMe: true,
            endpoint: firebaseAuth + 'verifyPassword' + firebaseKey,
            redirect: {
              success: '/new/otp',
            },
          },
          register: {
            endpoint: firebaseAuth + 'signupNewUser' + firebaseKey,
          },
          requestPass: {
            endpoint: firebaseAuth + 'getOobConfirmationCode' + firebaseKey,
          },
          refreshToken: {
            endpoint: 'https://securetoken.googleapis.com/v1/token' + firebaseKey,
          },
          // Firebase's response shapes, not Nebular's defaults.
          token: {
            key: 'idToken',
          },
          errors: {
            key: 'error',
          },
          messages: {
            key: 'message',
          },
        },
      },
    },
    forms: {
      login: {
        socialLinks: socialLinks,
      },
      register: {
        socialLinks: socialLinks,
      },
    },
  }).providers,
  FirebaseEmailPassAuthProvider,
  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  }).providers,
  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },
  AnalyticsService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
